import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0d2d6594&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0d2d6594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d6594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec/b2b/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2d6594')) {
      api.createRecord('0d2d6594', component.options)
    } else {
      api.reload('0d2d6594', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=0d2d6594&scoped=true&", function () {
      api.rerender('0d2d6594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Footer.vue"
export default component.exports